import { render, staticRenderFns } from "./ShenPiYongZhang.vue?vue&type=template&id=8393b25c&scoped=true&"
import script from "./ShenPiYongZhang.vue?vue&type=script&lang=js&"
export * from "./ShenPiYongZhang.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiYongZhang.vue?vue&type=style&index=0&id=8393b25c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8393b25c",
  null
  
)

export default component.exports